/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'wouter';

import useElementSize from '../../hooks/useElementSize';
import * as AppPropTypes from '../../lib/PropTypes';

import BasicButton from '../buttons/BasicButton';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../styles/cards/horizontal-card.module.css';

const propTypes = {
    href: PropTypes.string,
    thumbnail: PropTypes.node,
    thumbnailRatio: PropTypes.number,
    maxThumbnailWidthRatio: PropTypes.number,
    height: PropTypes.number,
    responsive: PropTypes.bool,
    children: PropTypes.node,
    inner: PropTypes.node,
    brand: PropTypes.string,
    isLabel: PropTypes.bool,
    labelFor: PropTypes.string,
    containerRef: AppPropTypes.ref,
    className: PropTypes.string,
    innerClassName: PropTypes.string,
    thumbnailClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    onClick: PropTypes.func,
};

const defaultProps = {
    href: null,
    thumbnail: null,
    thumbnailRatio: 4 / 3,
    maxThumbnailWidthRatio: 0.3,
    height: null,
    responsive: false,
    children: null,
    inner: null,
    brand: null,
    isLabel: false,
    labelFor: null,
    containerRef: null,
    className: null,
    innerClassName: null,
    thumbnailClassName: null,
    labelClassName: null,
    onClick: null,
};

function HorizontalCard({
    href,
    thumbnail,
    thumbnailRatio,
    maxThumbnailWidthRatio,
    height,
    responsive,
    children,
    inner,
    brand,
    isLabel,
    labelFor,
    containerRef,
    className,
    innerClassName,
    thumbnailClassName,
    labelClassName,
    onClick,
}) {
    const {
        ref,
        height: elementHeight = 0,
        width: elementWidth = 0,
    } = useElementSize({
        disabled: !responsive,
    });

    let thumbnailWidth = null;
    if (responsive) {
        thumbnailWidth =
            elementHeight > 0 && elementWidth > 0
                ? Math.min(elementHeight * thumbnailRatio, elementWidth * maxThumbnailWidthRatio)
                : null;
    } else if (thumbnailRatio !== null && height !== null) {
        thumbnailWidth = height * thumbnailRatio;
    }

    const thumbnailStyle = {
        minWidth:
            thumbnailWidth !== null
                ? `var(--card-thumbnail-width, var(--card-thumbnail-size, ${thumbnailWidth}px))`
                : null,
        width:
            thumbnailWidth !== null
                ? `var(--card-thumbnail-width, var(--card-thumbnail-size, ${thumbnailWidth}px))`
                : null,
        minHeight:
            height !== null
                ? `var(--card-thumbnail-height, var(--card-thumbnail-size, ${height}px))`
                : null,
    };

    const labelStyle = {
        marginLeft:
            responsive && thumbnailWidth !== null
                ? `var(--card-thumbnail-width, var(--card-thumbnail-size, ${thumbnailWidth}px))`
                : null,
        minHeight: 'var(--card-label-min-height, 100%)',
    };

    const Element = href !== null || onClick !== null ? 'span' : 'div';

    const cardInner = (
        <Element className={classNames([styles.inner, innerClassName])} ref={ref}>
            {thumbnail !== null ? (
                <Element
                    className={classNames([
                        styles.thumbnail,
                        {
                            [thumbnailClassName]: thumbnailClassName !== null,
                        },
                    ])}
                    style={thumbnailStyle}
                >
                    {thumbnail}
                </Element>
            ) : null}
            <Element
                className={classNames([
                    styles.label,
                    {
                        [labelClassName]: labelClassName !== null,
                    },
                ])}
                style={labelStyle}
            >
                {children}
            </Element>
            {inner}
        </Element>
    );

    if (isLabel) {
        return (
            <label
                className={classNames([
                    styles.container,
                    {
                        [styles.responsive]: responsive,
                        [className]: className !== null,
                    },
                ])}
                htmlFor={labelFor}
                ref={containerRef}
                data-brand={brand}
            >
                {cardInner}
            </label>
        );
    }

    if (href !== null) {
        return (
            <Link
                href={href}
                onClick={onClick}
                className={classNames([
                    styles.container,
                    {
                        [styles.responsive]: responsive,
                        [className]: className !== null,
                    },
                ])}
                ref={containerRef}
                data-brand={brand}
            >
                {cardInner}
            </Link>
        );
    }
    if (onClick !== null) {
        return (
            <BasicButton
                onClick={onClick}
                className={classNames([
                    styles.container,
                    {
                        [styles.responsive]: responsive,
                        [className]: className !== null,
                    },
                ])}
                data-brand={brand}
            >
                {cardInner}
            </BasicButton>
        );
    }
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.responsive]: responsive,
                    [className]: className !== null,
                },
            ])}
            ref={containerRef}
            data-brand={brand}
        >
            {cardInner}
        </div>
    );
}

HorizontalCard.propTypes = propTypes;
HorizontalCard.defaultProps = defaultProps;

export default React.forwardRef((props, ref) => <HorizontalCard {...props} containerRef={ref} />);
